import { useColorScheme } from '../theme/useColorScheme';

import { MoonIcon, SunIcon } from './icons';
import styles from './ColorSchemeSwitch.module.css';

/**
 * Light or dark, on every screen.
 *
 * It lived in the application shell, which only exists after sign-in — so the
 * first screen anybody sees had no way to change the scheme, and the setting
 * appeared not to exist.
 *
 * Two options rather than one flipping button. A single toggle has to be
 * labelled either with the state it is in or the state it moves to, and both
 * readings are available to a reader who cannot tell which convention was
 * chosen. Showing both, with the current one marked, removes the question:
 * §4.2 asks that state never rest on colour alone, so the active option is
 * carried by a filled surface, the label, and `aria-pressed` together.
 */
export function ColorSchemeSwitch({ fullWidth = false }: { readonly fullWidth?: boolean }) {
  const { scheme, setPreference } = useColorScheme();

  return (
    <div
      className={fullWidth ? styles.groupFull : styles.group}
      role="group"
      aria-label="مظهر الواجهة"
    >
      <button
        type="button"
        className={scheme === 'light' ? styles.optionActive : styles.option}
        aria-pressed={scheme === 'light'}
        aria-label="الوضع الفاتح"
        onClick={() => {
          setPreference('light');
        }}
      >
        <SunIcon className={styles.icon} />
      </button>

      <button
        type="button"
        className={scheme === 'dark' ? styles.optionActive : styles.option}
        aria-pressed={scheme === 'dark'}
        aria-label="الوضع الداكن"
        onClick={() => {
          setPreference('dark');
        }}
      >
        <MoonIcon className={styles.icon} />
      </button>
    </div>
  );
}
